import api from 'lib/api'

export function isEmailAvailable(email: string) {
  return api
    .get<{ data: { isEmailAvailable: boolean } }>(
      `/api/v2/users/email-available`,
      {
        params: { email },
      },
    )
    .then(({ data }) => data.data.isEmailAvailable)
}

export function isPhoneAvailable(phone: string) {
  return api
    .get<{ data: { isPhoneAvailable: boolean } }>(
      `/api/v2/users/email-available`,
      {
        params: { phone },
      },
    )
    .then(({ data }) => data.data.isPhoneAvailable)
}




